import React, { ButtonHTMLAttributes, ReactNode } from "react";

export interface SecondaryBtnProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "style"> {
  color?: "main-gr" | "gray";
  children?: ReactNode;
  disabled?: boolean;
}

const getTailwind = (color: string, disabled: boolean) => {
  if (disabled) {
    return "bg-[#eeeeee] text-[#888888] font-bold";
  } else {
    if (color === "main-gr") {
      return "bg-gradient-to-r from-[#ab38a6] via-[#4927b9] to-[#2b78cf] text-white font-bold hover:from-[#8a2a7e] hover:via-[#3a1e7e] hover:to-[#205a8c]";
    }
    if (color === "gray") {
      return "bg-[#212121] text-white font-bold hover:bg-[#4d4d4d]";
    }
  }
  return "bg-gradient-to-r from-[#cd3ec7] via-[#5328df] to-[#2d8efa] text-white font-bold";
};

const Secondary: React.FC<SecondaryBtnProps> = ({
  color = "main-gr",
  disabled = false,
  className,
  ...props
}) => {
  const base =
    "flex items-center justify-center h-[40px] px-[20px] py-0 rounded-[8px] text-[14px] leading-[20px] tracking-[-0.28px] text-center font-bold transition-all duration-200 whitespace-nowrap";
  const tw = getTailwind(color, disabled);

  return (
    <button
      className={`${base} ${tw} ${className || ""}`}
      disabled={disabled}
      type="button"
      {...props}
    />
  );
};

export default Secondary;
